import { getEnvironmentVariable } from "../../global/environmentVariables";
import { getData } from "../utilities/UtilityFunctions";

const searchLimit = 100;
const ignoreEmptySearchList = [
  "/admin/exports",
  "/armies",
  "/armylists",
  "/armyunits",
  "/eventroles",
  "/events",
  "/gamestores",
  "/gamestoreusers",
  "/gamesystems",
  "/leagues",
  "/leaguetokens",
  "/locations",
  "/placings",
  "/products",
  "/productcategories",
  "/scorecards",
  "/storetransactions",
  "/teams",
  "/transactions",
  "/users",
  "/pairings",
  "/players",
  "/teamplayers",
];

const regionDictionary = {
  oKTemm6D3O: "Scotland",
  xpASeuxjgV: "Northern Ireland",
  sN2gjxAFEq: "Wales",
  WWGP6AWFfq: "England",
  VqdvqrCb9o: "New Zealand",
  "8caheRYkYV": "South Pacific",
  EqkMEfhFkf: "Scandinavia",
  I9x1u9bn5b: "Canada",
  PN9BPGyIFo: "Ireland",
  fC2TUH8MXe: "United Kingdom",
  AafMLg4fTZ: "Vatican City",
  kNjI09j03u: "Ukraine",
  rmf7SDEBYh: "Yugoslavia",
  HC3EmOK4I6: "Switzerland",
  "3DGHTEfjRp": "Sweden",
  "7oVuO1Cse6": "Spain",
  z1XUaiGrNL: "Slovakia",
  WuuU21pvAT: "Slovenia",
  ecAu7B2Da1: "Romania",
  "6tVwFFKQtJ": "San Marino",
  yN3mkRrPGF: "Serbia",
  tOWD5vgl95: "Russia",
  QgC0EmMN6l: "Poland",
  vKNZ7DCkq1: "Portugal",
  p6roL5CBjJ: "Netherlands",
  YHazUXcsK9: "Norway",
  WWzSmC4tHP: "Montenegro",
  QDYr8IjvUO: "Monaco",
  b0DiHrBD14: "Lithuania",
  HeLAkG1Hye: "Latvia",
  bdIDRyzWiL: "Kosovo",
  "2S8c1WF6RK": "Luxembourg",
  Krn5jyFfop: "Moldova",
  JmWlAbqcK8: "Malta",
  DnCcwT9Puf: "Macedonia",
  ub43ZGxBe8: "Liechtenstein",
  eDAe4MN5bU: "France",
  TQHDW5syEr: "Greece",
  V1BKEJXo5W: "Finland",
  Sg0bBNySH8: "Isle of Man",
  "3ASOJvOnsN": "Germany",
  Fr0ChVhzWE: "Hungary",
  oDgmJ4LBCm: "Italy",
  Uvkw4n4bjL: "Gibraltar",
  k4hEsXaulB: "Iceland",
  MrId5wz6pL: "Faroe Islands",
  "0BRmj5rrNR": "Estonia",
  IQrsWTSUZk: "Cyprus",
  KSw8EBXD6a: "Denmark",
  YMsfxPcPFP: "Czech Republic",
  "8WD6AQZl9B": "Bulgaria",
  fBPrFqOKPD: "Bosnia",
  aH0zH0fT7q: "Belarus",
  vpVOLuiebo: "Croatia",
  "7gdTJtwwlj": "Belgium",
  xhLSH4CfVE: "Austria",
  "6DuBXuvlK9": "US-Southwest",
  FUtsJUxsHL: "US-South",
  tpA7Ftk4IV: "Andorra",
  "9FmG4A5zta": "US-Northeast",
  d07MGnyeoa: "Albania",
  o71JAFvyjt: "US-Midwest",
  "61vXu5vli4": "Global",
  YPl3gSwfYa: "Australia",
  V4oYeyTAPe: "Europe",
  ERrHMJo9H5: "US-West",
  VgQKgqmTPU: "United States",
};

export function getGlobalRegion() {
  return {
    id: "61vXu5vli4",
    name: "Global",
  };
}

export function getRegionsArray() {
  return [
    {
      id: "61vXu5vli4",
      name: "Global",
    },
    {
      id: "VgQKgqmTPU",
      name: "USA",
      children: [
        {
          id: "ERrHMJo9H5",
          name: "US West",
        },
        {
          id: "6DuBXuvlK9",
          name: "US SouthWest",
        },
        {
          id: "FUtsJUxsHL",
          name: "US South",
        },
        {
          id: "9FmG4A5zta",
          name: "US NorthEast",
        },
        {
          id: "o71JAFvyjt",
          name: "US Mid-West",
        },
      ],
    },
    {
      id: "I9x1u9bn5b",
      name: "Canada",
    },
    {
      id: "8caheRYkYV",
      name: "Oceania",
      children: [
        {
          id: "YPl3gSwfYa",
          name: "Australia",
        },
        {
          id: "VqdvqrCb9o",
          name: "New Zealand",
        },
      ],
    },
    {
      id: "fC2TUH8MXe",
      name: "UK",
    },
    {
      id: "EqkMEfhFkf",
      name: "Scandinavia",
    },
    {
      id: "V4oYeyTAPe",
      name: "Europe",
    },
  ];
}

function findChildRegion(regions, regionId) {
  for (let i = 0; i < regions?.length; i++) {
    if (regions[i]?.id === regionId) {
      return regions[i];
    }
    if (regions[i]?.children?.length) {
      let _region = findChildRegion(regions[i]?.children, regionId);
      if (_region) {
        return _region;
      }
    }
  }
  return undefined;
}

function findChildRegionForHierarchy(regions, regionId) {
  for (let i = 0; i < regions?.length; i++) {
    if (regions[i]?.id === regionId) {
      return [regions[i]];
    }
    if (regions[i]?.children?.length) {
      let _regions = findChildRegionForHierarchy(
        regions[i]?.children,
        regionId
      );
      if (_regions?.length) {
        return [regions[i], ..._regions];
      }
    }
  }
  return undefined;
}

export function findRegionHierarchy(regions, regionId) {
  return findChildRegionForHierarchy(regions, regionId);
}

export function getRegionName(regionId, regions) {
  if (regions && Array.isArray(regions)) {
    let _region = findChildRegion(regions, regionId);
    if (_region) {
      return _region?.name;
    }
  }
  return regionDictionary[regionId];
}

export function getRegion(regionId, regions) {
  if (regions && Array.isArray(regions)) {
    let _region = findChildRegion(regions, regionId);
    if (_region) {
      return _region;
    }
  }
  return undefined;
}

export function getRegionHierarchy(regionId) {
  return regionDictionary[regionId];
}

export async function handlePaging(
  endPoint,
  filters,
  nextKey,
  setNextKey,
  apiName
) {
  const queryStringParameters = {
    limit: searchLimit,
    ...filters,
  };
  if (nextKey) {
    queryStringParameters.nextKey = nextKey;
  }
  const apiGetData = await getData(
    endPoint,
    {
      queryStringParameters: queryStringParameters,
    },
    apiName
  );

  if (nextKey) {
    if (apiGetData.nextKey === nextKey) {
      return [];
    }
  }

  setNextKey(apiGetData.nextKey);

  return apiGetData.data;
}

export async function handlePagingAll(endPoint, filters, setData, apiName) {
  const ignoreEmptySearch = ignoreEmptySearchList.includes(
    endPoint.toLowerCase()
  );
  const fetchData = async (nextKey, previousData) => {
    const queryStringParameters = {
      limit: searchLimit,
      ...filters,
    };
    if (nextKey) {
      queryStringParameters.nextKey = nextKey;
    }
    const apiGetData = await getData(
      endPoint,
      {
        queryStringParameters: queryStringParameters,
      },
      apiName
    );

    if (nextKey && apiGetData.nextKey === nextKey) {
      return { data: [] };
    }

    var newData;
    if (setData) {
      if (previousData?.length > 0) {
        newData = [...previousData, ...apiGetData.data];
      } else {
        newData = apiGetData.data;
      }

      setData(newData);
    }

    if (
      apiGetData.data?.length !== 0 &&
      apiGetData.nextKey &&
      apiGetData.nextKey !== nextKey &&
      (apiGetData.data?.length === queryStringParameters.limit ||
        !ignoreEmptySearch)
    ) {
      var nextFetch = await fetchData(apiGetData.nextKey, newData);
      if (nextFetch?.data?.length > 0) {
        apiGetData.data = [...apiGetData.data, ...nextFetch.data];
      }
    }

    return apiGetData;
  };

  var apiData = await fetchData();
  return apiData.data;
}

export async function getGameSystems(filters) {
  try {
    let queryParams = {
      "expand[]": ["image", "logo", "defaultEventImage"],
    };
    if (filters) {
      queryParams = {
        ...queryParams,
        ...filters,
      };
    }
    if (getEnvironmentVariable("SINGLE_GAME_TYPE")) {
      queryParams.gameType = getEnvironmentVariable("SINGLE_GAME_TYPE");
    } else if (getEnvironmentVariable("SINGLE_GAME_MANUFACTURER")) {
      queryParams.manufacturer = getEnvironmentVariable(
        "SINGLE_GAME_MANUFACTURER"
      );
    }
    var gameSystems = await handlePagingAll("/gamesystems", queryParams);

    if (gameSystems?.length > 0) {
      gameSystems.sort((a, b) => {
        if (a.manufacturerOrderNum === b.manufacturerOrderNum) {
          if (a.manufacturer !== b.manufacturer) {
            var manufacturerA = a.manufacturer.toLowerCase();
            var manufacturerB = b.manufacturer.toLowerCase();
            if (manufacturerA > manufacturerB) return 1;
            if (manufacturerA < manufacturerB) return -1;
          }
          return a.gameSystemOrderNum - b.gameSystemOrderNum;
        }
        return a.manufacturerOrderNum - b.manufacturerOrderNum;
      });
    }
    return gameSystems;
  } catch (err) {
    throw err;
  }
}
export async function getArmies(filters) {
  try {
    var armies = await handlePagingAll("/armies", filters);
    var armyArray = [];
    if (armies?.length > 0) {
      armies.sort((a, b) => {
        var nameA = a.name.toLowerCase();
        var nameB = b.name.toLowerCase();
        if (nameA > nameB) return 1;
        if (nameA < nameB) return -1;
        return 0;
      });
      armies.forEach((army) => {
        if (army.ITCFactionId && army.ITCFactionId !== army.id) {
          army.parentFactionId = army.ITCFactionId;
        } else {
          army.childArmies = [];
          armyArray.push(army);
        }
      });
      armies.forEach((army) => {
        if (army.parentFactionId) {
          armyArray.forEach((parentArmy) => {
            if (parentArmy.id === army.parentFactionId) {
              parentArmy.childArmies.push(army);
            }
          });
        }
      });
    }
    return armyArray;
  } catch (err) {
    throw err;
  }
}

export async function getArmyPickerArmies(gameSystemId, filters) {
  try {
    const apiArmies = await handlePagingAll(
      `/gamesystems/${gameSystemId}/factions`,
      filters
    );

    // Create army array
    function createArmyArray(armies) {
      const armyArray = [];

      if (armies?.length > 0) {
        armies.forEach((army) => {
          if (army?.subFactions?.length > 0) {
            // Sort sub factions alphabetically
            army?.subFactions.sort((a, b) => {
              const nameA = a?.name?.toLowerCase();
              const nameB = b?.name?.toLowerCase();
              if (nameA > nameB) return 1;
              if (nameA < nameB) return -1;
              return 0;
            });
          }

          if (!army?.superFaction?.id) {
            armyArray.push(army);
          }
        });

        // Sort factions without super factions alphabetically by name
        armyArray.sort((a, b) => {
          const nameA = a?.name?.toLowerCase();
          const nameB = b?.name?.toLowerCase();
          if (nameA > nameB) return 1;
          if (nameA < nameB) return -1;
          return 0;
        });

        let superFactions = [];

        armies.forEach((army) => {
          if (army?.superFaction?.id) {
            superFactions.push({ ...army.superFaction });
          }
        });

        // Remove duplicate super factions
        superFactions = superFactions.filter(
          (superFaction, index, self) =>
            index === self.findIndex((t) => t.id === superFaction.id)
        );

        // Sort super factions alphabetically
        superFactions.sort((a, b) => {
          const nameA = a?.name?.toLowerCase();
          const nameB = b?.name?.toLowerCase();
          if (nameA > nameB) return 1;
          if (nameA < nameB) return -1;
          return 0;
        });

        // Add child armies to each super faction
        superFactions.forEach((superFaction) => {
          superFaction.childArmies = [];
          armies.forEach((army) => {
            if (army?.superFaction?.id === superFaction?.id) {
              const armyCopy = { ...army };

              // Prevents circular reference
              delete armyCopy.superFaction;

              superFaction.childArmies.push(armyCopy);
            }
          });
        });

        // Sort each super faction's child armies alphabetically
        superFactions.forEach((superFaction) => {
          superFaction.childArmies.sort((a, b) => {
            const nameA = a?.name?.toLowerCase();
            const nameB = b?.name?.toLowerCase();
            if (nameA > nameB) return 1;
            if (nameA < nameB) return -1;
            return 0;
          });
        });

        // Push superfactions to armyArray
        armyArray.push(...superFactions);
      }

      return armyArray;
    }

    // Create subFaction dictionary
    function createSubFactionDict(armyArray) {
      const subFactionDict = {};

      if (armyArray?.length > 0) {
        apiArmies.forEach((army) => {
          var subFactions = [];
          if (army.subFactions?.length) {
            army.subFactions.forEach((subFaction) => {
              subFactions.push({
                value: subFaction.id,
                label: subFaction.name,
              });
            });

            subFactions.sort((a, b) => {
              var labelA = a.label.toLowerCase();
              var labelB = b.label.toLowerCase();
              if (labelA > labelB) return 1;
              if (labelA < labelB) return -1;
              return 0;
            });
          }
          subFactionDict[army.id] = subFactions;
        });
      }

      return subFactionDict;
    }

    const armyArray = createArmyArray(apiArmies);
    const subFactionDict = createSubFactionDict(armyArray);

    return { armyArray, subFactionDict };
  } catch (err) {
    throw err;
  }
}
